import { Button } from 'components/Button'
import type { StrapiLink } from 'types/strapi/link'

export interface PercentDataProps {
  number: string
  description: string
  sources: StrapiLink[] | null
}

export default function PercentData({
  number,
  description,
  sources,
}: PercentDataProps) {
  return (
    <div className="h-auto overflow-hidden bg-black">
      <div className="mx-auto max-w-[1400px] px-4 py-4 text-medium-beige md:px-8">
        <h2 className="flex flex-col items-center justify-center md:flex-row">
          <div>
            <span className="text-[80px] font-bold md:text-[140px]">
              {number}
            </span>
            <span className="relative self-end text-[80px]">%</span>
          </div>
          <div className="max-w-[500px] text-center text-2xl font-medium md:ml-10 md:text-left">
            {description}
          </div>
        </h2>
        {sources ? (
          <div className="mt-6 flex flex-col items-center justify-center text-white opacity-40 md:mt-0 md:flex-row md:space-x-2">
            {sources.map(source =>
              source.url ? (
                <Button
                  key={source.title}
                  href={source.url}
                  variant="raw"
                  className="p-4 text-sm"
                >
                  {source.title}
                </Button>
              ) : (
                <div key={source.title} className="p-4 text-sm">
                  {source.title}
                </div>
              ),
            )}
          </div>
        ) : null}
      </div>
    </div>
  )
}
